export const PERSON_EVENT_TYPE = "een.personDetectionEvent.v1";
export const MOTION_EVENT_TYPE = "een.motionDetectionEvent.v1";

/**
 * Inspect incident events to determine which EEN event types are present.
 * Each incident event has a `data` field that is a JSON string containing
 * a Motion message, where `parsed.data.type` holds the original EEN type.
 */
export function derivePreferredEenEventType(incidentEvents) {
  let hasPerson = false;
  let hasMotion = false;

  if (!Array.isArray(incidentEvents)) {
    return {
      hasPerson,
      hasMotion,
      preferred: null,
      allowFallbackToMotion: true,
    };
  }

  incidentEvents.forEach((event) => {
    if (!event || event.data == null) return;

    let parsed;
    try {
      // data can be a stringified JSON or already an object
      parsed =
        typeof event.data === "string" ? JSON.parse(event.data) : event.data;
    } catch (_e) {
      return;
    }

    const innerType = parsed?.data?.type;
    if (innerType === PERSON_EVENT_TYPE) {
      hasPerson = true;
    } else if (innerType === MOTION_EVENT_TYPE) {
      hasMotion = true;
    }
  });

  // Only person events present → always use person
  if (hasPerson && !hasMotion) {
    return {
      hasPerson,
      hasMotion,
      preferred: PERSON_EVENT_TYPE,
      allowFallbackToMotion: false,
    };
  }

  // Only motion events present → always use motion
  if (hasMotion && !hasPerson) {
    return {
      hasPerson,
      hasMotion,
      preferred: MOTION_EVENT_TYPE,
      allowFallbackToMotion: false,
    };
  }

  // Both present OR none recognized → start with person, allow fallback
  return {
    hasPerson,
    hasMotion,
    preferred: PERSON_EVENT_TYPE,
    allowFallbackToMotion: true,
  };
}
